<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
        <div class="container">
            <div class="row p-5 text-center" v-if="showWaiting">
                <p class="title">{{ translate.msgWaiting }}</p>
            </div>            
            <div class="row p-5 text-center" v-if="showFailed">
                <p class="title">{{ translate.cancelFailedText1 }} {{ userName }},</p>
                <p class="text" v-html="translate.cancelFailedText2"></p>
                <p class="text" v-html="translate.cancelFailedText3"></p>
            </div>
            <div class="row p-5 text-center" v-if="showConfirmed">
                <p class="title">{{ translate.cancelConfirmedText1 }} {{ userName }},</p>
                <p class="text">{{ translate.cancelConfirmedText2 }}</p>
                <p class="text">{{ translate.cancelConfirmedText3 }} {{ expirationDate }}.</p>
                <p class="text">{{ translate.cancelConfirmedText4 }} <br> {{ translate.cancelConfirmedText5 }}</p>
            </div>
        </div>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import api from '../../api'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/cancelsubscribe'

export default defineComponent({
  name: 'CancelSubscribeView',
  computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
          if (this.locale === 'pt-br') {
              return tradutor.portugues
          } else {
              return tradutor.ingles
          }
      }
  },

  data() {
    return {
        showWaiting: true,        
        showFailed: false,
        showConfirmed: false,
        userName: '',
        expirationDate: ''
    }
},

  created() {
    this.setConfirmCancel()
  },
  methods: {
    setConfirmCancel() {
        api.get('v1/myaccount/confirmCancelOrder/'+this.$route.params.token).then(({ data }) => {
            this.showWaiting = false
            if (data.returnStatus == "failed") {
                this.showFailed = true
                this.userName = data.userName
            } else if (data.returnStatus == "confirmed") {
                this.showConfirmed = true
                this.userName = data.userName
                this.expirationDate = data.expirationDate
            }
            this.$cookies.remove('cancelOrder')            
        }).catch((error) => console.log(error))

    }
  }
})
</script>

<style scoped lang="css">

.slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
    font-size: 20px;
}

.title {
    margin-top: 30px;
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
}

.text {
    margin-top: 10px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 25px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {

}
</style>
